import React, { Component } from 'react'
import Leaflet from 'leaflet';
import { Map, TileLayer, Marker } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';

Leaflet.Icon.Default.imagePath =
'../node_modules/leaflet'

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});



export default class SimpleMap extends Component {
state = {
    lat: 51.505,
    lng: -0.09,
    zoom: 13,
}


render() {
    const position = [this.state.lat, this.state.lng];
    return (
    <Map center={position} zoom={this.state.zoom} style={{height : '300px'}}>
        <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
        </Marker>
    </Map>
    )
}
}